import React, { useState, useEffect } from "react";
import { ProgressBar } from "primereact/progressbar";
import "./styles.css";

const ProgressClientBar = ({
  title,
  totalAnnual,
  progressTotal,
  currentMonthIndex = new Date().getMonth() // 0 = Enero
}) => {
  const [progressValue, setProgressValue] = useState(0);

  useEffect(() => {
    const monthlyPercentage = 100 / 12;
    const expectedPercentageToDate =
      (currentMonthIndex + 1) * monthlyPercentage;

    const actualProgressPercentage = (progressTotal / totalAnnual) * 100;

    const clampedProgress = Math.min(
      actualProgressPercentage,
      expectedPercentageToDate
    );

    setProgressValue(Number(clampedProgress.toFixed(2)));
  }, [totalAnnual, progressTotal, currentMonthIndex]);

  return (
    <div className="progress-client-bar">
      <h1 className="progress-label-title">{title}</h1>

      <ProgressBar value={progressValue} className="custom-progress-bar" />

      {/* <div style={{ display: "flex", justifyContent: "space-around" }}>
        {[
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic"
        ].map((text, index) => (
          <div key={index}>
            <p className="progress-label-text">{text}</p>
          </div>
        ))}
      </div> */}
    </div>
  );
};

export default ProgressClientBar;
